import styled from 'styled-components'

export const Info = styled.p`
  margin-bottom: 8px;
`

export const QuantityContainer = styled.div`
  margin-bottom: 24px;
`

export const InputContainer = styled.div`
  width: 200px;
`
